import { useEffect } from 'react';
import { httpClient } from '@/httpClient/axios.ts';
import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { useLayer } from '@/layers/useLayer.tsx';
import { isLocalDev } from '@/util/isLocalDev.ts';

// This component verifies that the event has not
// expired and shows a message if it has.
export const EventVerification = () => {
  const { eventConfig } = useEventConfig();
  const { showLayer } = useLayer();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!isLocalDev() && eventConfig && eventConfig.meta.eventStatusURL) {
      const url = eventConfig.meta.eventStatusURL;
      httpClient.head(url).catch((_e) => {
        showLayer({ ref: '@eventUnavailable' });
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 10_000);
      });
    }
  }, [eventConfig?.meta.eventStatusURL]);

  return null;
};
